module.exports = __webpack_public_path__ + "img/dream_catcher.76625b9.jpg";